export const mainColor = "linear-gradient(to bottom, #007aff, #00111c)";

export const subColor = "#2F4858";

export const selectColor = "#675A90";

export const selectLighter = "#9C5897";
